<script lang="ts">
	import { onMount } from 'svelte';
	import ArrowUp from 'assets/svg/arrowUp.svg?component';
	import ArrowDown from 'assets/svg/arrowDown.svg?component';
	import SearchIcon from 'assets/svg/searchIcon.svg?component';
	import formatString from 'utils/formatString';

	interface IFilters {
		value: string;
		name: string;
	}

	export let query: string = '';
	export let filters: IFilters[];
	export let dark: boolean = false;
	export let handleClick: (arg1: string | number | object) => void = () => {};
	export let minWidth: number;
	export let alignStart = false;
	export let selectedScale = filters[0];
	export let selectObject = false;
	export let placeholder = 'Search..';
	let inputRef;
	let isOpen = false;
	let filtered: IFilters[] = [];

	function onSearch() {
		const formattedQuery = formatString(query);
		filtered = filters.filter(
			(item) =>
				formatString(item.name).includes(formattedQuery) ||
				formatString(item.value).includes(formattedQuery),
		);
	}

	onMount(() => {
		document.addEventListener('click', handleClose);

		return () => {
			document.removeEventListener('click', handleClose);
		};
	});

	const handleClose = (e: Event) => {
		if (inputRef && !inputRef.contains(e.target)) {
			isOpen = false;
		}
	};
</script>

<div class="wrapper" class:dark bind:this={inputRef}>
	<div
		class="scale-wrapper"
		style={`min-width: ${minWidth}px; justify-content: ${alignStart ? 'flex-start' : 'flex-end'}`}
		on:click={() => {
			isOpen = !isOpen;
			query = '';
		}}
	>
		<div class="selected-item" class:selected={selectedScale.name !== 'all'}>
			<p class="selected-scale">
				{selectedScale.name}
			</p>
		</div>

		{#if isOpen}
			<ArrowUp class={`select-icon ${dark ? 'dark' : ''}`} width={8} height={8} />
		{:else}
			<ArrowDown class={`select-icon ${dark ? 'dark' : ''}`} width={8} height={8} />
		{/if}
	</div>
	<div class="dropdown" class:visible={isOpen}>
		<div class="search-wrapper" class:not-empty={query}>
			<input type="text" class="input" {placeholder} bind:value={query} on:keyup={onSearch} />
			<SearchIcon width="12" height="12" class="search-icon center" />
		</div>
		<ul class="filters">
			{#each filtered && query !== '' ? filtered : filters as filter}
				<li
					class="item"
					on:click={() => {
						isOpen = !isOpen;
						selectedScale = filter;
						handleClick(selectObject ? filter : filter.value);
					}}
				>
					{filter.name}
				</li>
			{/each}
		</ul>
	</div>
</div>

<style lang="scss">
	@import 'filterWithSearch';
</style>
